<template>
    <div class="go-verify-email">
        <v-container class="">
            <v-row class="ma-8">
                <v-card class="mx-auto my-10" color="primary" max-width="700">
                    <v-card-title class="info--text">
                        Please Check your mailbox and verify your email to proceed!
                    </v-card-title>
                    <v-card-subtitle>
                        - Your Concierge Team
                    </v-card-subtitle>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {auth} from '@/fb'

export default {
    name:"GoVerifyEmail",
    data(){
        return {

        }
    },
    created(){
        if(auth.currentUser.emailVerified){
            this.$router.push({name:'dashboard'})
        }
    }
}
</script>